<!-- <div class="section" *ngIf="hasContent || editModeSet" [ngClass]="nonEnterpriseRentalCars.length == 1 ? 'SingleNonEnterpriseElement' : 'MultipleNonEnterpriseElements' "> -->
<div class="section" *ngIf="hasContent || (editModeSet && !isRegionalManager)">
  <div class="section__header">
    <h2 class="section__header-text">Rental Cars
      <mat-icon (click)="openEditRentalCarsDialog(['Rental Car::'], null, 'Rental Cars')" *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
    </h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <!-- <div *ngIf="hasTag(this.business.tags, 'Rental Car::Enterprise')"
           class="data-block__item">
        <div class="data-block__value">
          <img src="assets/images/enterprise.png" class="rentals-cars__enterprise" alt="Enterprise">
        </div>
        <div class="data-block__value">(866) 315-9155</div>
        <div class="data-block__value">
          <a href="https://www.aopa.org/membership/aopa-car-discount-program" target="_blank">BOOK NOW!</a>
        </div>
      </div> -->
      <!-- <div class="data-block__item" *ngFor="let rentalCar of nonEnterpriseRentalCars"> -->
      <!-- <div class="data-block__item" *ngFor="let rentalCar of allRentalCars">
        <div class="data-block__value">{{ rentalCar }}</div>
      </div> -->
      <!-- <ng-container *ngIf="editModeSet && !hasTag(this.business.tags, 'Rental Car::Enterprise') && nonEnterpriseRentalCars.length < 1"> -->
      <div class="data-block__value">
        <app-tag-bullet-list *ngIf="_rentalCarTags && _rentalCarTags.length" [items]="_rentalCarTags"></app-tag-bullet-list>
        <div *ngIf="(editModeSet && !isRegionalManager) && !_rentalCarTags.length">
          <p>None Selected</p>
        </div>
      </div>
    </div>
  </div>
